import { checkHasPermission } from "shared/imports/permissionFunctions"
import { isFeatureEnabled } from "shared/featureflags/helperFunctions"

const { PermissionType } = DjangIO.app.models

export const actionCentersBannerText =
    "Welcome to the Action Center management system! Please choose which Action Center you'd like to" +
    " work on to continue. If you'd like to add an additional Action Center, please "
export const getSingleActionCenterBannerText = (name, isSingleActionCenter) => {
    if (checkHasPermission([PermissionType.action_center])) {
        return (
            `Welcome to the ${name} management homepage. From here you can launch a new campaign, add additional` +
            ' pages, change settings, and more. If you\'re new we suggest that you start in "Campaigns" to' +
            " launch a campaign.\n" +
            (isSingleActionCenter
                ? "If you would like to add an additional separate Action Center, please contact us.\n"
                : "") +
            " If you'd like an introduction to Quorum Grassroots, "
        )
    } else if (checkHasPermission([PermissionType.external_interactions, PermissionType.external_relationship])) {
        return (
            "Welcome to the Action Center homepage. From here, you can customize your settings," +
            " personalize your interaction loggers, add issues, and more."
        )
    } else if (checkHasPermission([DjangIO.app.models.PermissionType.stakeholder])) {
        return (
            "Welcome to the Action Center homepage. From here, you can make customized registration forms" +
            " to embed in your action center and change your display settings."
        )
    }
}
export const issuesTableBannerText =
    "You can choose to show a subset of your Issues publicly on your Action Center and enable your advocates" +
    " to learn more about your issues or take action in your particular issue area. For more information, "
export const registrationsTableBannerText =
    "Registration Forms control what information you'd like to collect from your advocates as they use your" +
    " Action Center." +
    (checkHasPermission([PermissionType.action_center])
        ? " Every campaign can have a different registration form, which means you that you can" +
          " require different custom fields, etc. on different campaigns. Additionally, you" +
          " can embed registration forms independently on your website to collect emails," +
          " addresses, and more without directing users to your campaigns. For more on registration" +
          " forms, "
        : " You can embed registration forms independently on your website to collect emails, addresses," +
          " and more. For more on registration forms, ")
export const pagesTableBannerText =
    "Pages allow you to create custom layouts for your Action Center homepage or add additional pages to your" +
    " Action Center (like 'About Us' or initiative-specific pages). You can add these pages to your Action" +
    " Center' navigation bar through "
export const actionCenterPaintings = {
    campaigns: {
        content: "Launch a new campaign or manage your existing campaigns.",
        heading: "Campaigns",
        icon: "bullhorn",
        iconFamily: "fad",
        dataCy: "painting-Campaigns",
        order: 1,
    },
    registration: {
        content: isFeatureEnabled("ff_pac")
            ? "Set up a dedicated registration or donation form and customize what information " +
              "you ask from Grassroots advocates or PAC members."
            : "Set up a dedicated registration form or customize what information you ask from your advocates.",
        heading: isFeatureEnabled("ff_pac") ? "Forms" : "Registration Forms",
        icon: "edit",
        iconFamily: "fad",
        dataCy: "painting-Forms",
        order: 2,
    },
    issues: {
        content: "Choose which of your issues should be displayed on your action center and change their settings.",
        heading: "Issues",
        icon: "thumbtack",
        iconFamily: "fad",
        dataCy: "painting-Issues",
        order: 3,
    },
    pages: {
        content: "Change the layout of your homepage or add additional pages to your Action Center.",
        heading: "Pages",
        icon: "file-alt",
        iconFamily: "fad",
        dataCy: "painting-Pages",
        order: 4,
    },
    events: {
        content: "Set up your event and its page, manage your RSVPs, and report on who attended.",
        heading: "Events",
        icon: "calendar-check",
        iconFamily: "fad",
        dataCy: "painting-Events",
        order: 5,
    },
    settings: {
        content: "Control your Action Center's appearance, security, and much more.",
        heading: "Settings",
        icon: "cog",
        iconFamily: "fad",
        dataCy: "painting-Settings",
        order: 6,
    },
}
